import { render, staticRenderFns } from "./PriceBreakdown.vue?vue&type=template&id=6ea557ce&scoped=true"
import script from "./PriceBreakdown.vue?vue&type=script&lang=js"
export * from "./PriceBreakdown.vue?vue&type=script&lang=js"
import style0 from "./PriceBreakdown.vue?vue&type=style&index=0&id=6ea557ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea557ce",
  null
  
)

export default component.exports